<ng-container *appHideIfEmbedModeIsSet>
  <ng-container *ngIf="router.url.split('/')[1] !== 'respondent'">
    <nav class="ctm-navbar" *ngIf="logged$ | async">
      <div class="brand">
        <a [routerLink]="['/']">
          <h2>Zoom</h2>
        </a>
        <div class="reporting-dropdown icon-container" dropdown>
          <a class="icon" dropdownToggle><span class="icomoon icon-menu"></span></a>
          <ul
            id="dropdown-basic"
            *dropdownMenu
            class="dropdown-menu dropdown-menu-right"
            role="menu"
            aria-labelledby="button-basic"
          >
            <li role="menuitem">
              <a class="dropdown-item" [class.disabled]="!appsAuthMap.admin" (click)="navigateTo('admin')">
                <span class="left-icon icomoon icon-admin"></span>
                Admin Application
              </a>
            </li>
            <li role="menuitem">
              <a class="dropdown-item" [class.disabled]="!appsAuthMap.planner" (click)="navigateTo('planner')">
                <span class="left-icon icomoon icon-planner"></span>
                Planner Application
              </a>
            </li>
            <li role="menuitem">
              <a class="dropdown-item" [class.disabled]="!appsAuthMap.reporting" (click)="navigateTo('reporting')">
                <span class="left-icon icomoon icon-reporting"></span>
                Reporting Application
              </a>
            </li>
            <li role="menuitem">
              <a class="dropdown-item" [class.disabled]="!appsAuthMap.dashboard" (click)="navigateTo('dashboard')">
                <span class="left-icon icomoon icon-dashboard"></span>
                Dashboard Application
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div class="application">
        <h3 (click)="navigateTo(router.url.split('/')[1])">{{ appNameFromPath(router.url.split('/')[1]) }}</h3>
      </div>

      <div class="rightContainer">
        <ng-container *ngIf="user$ | async as user">
          <a [routerLink]="['/login']">
            <span class="user">
              <span class="icon icomoon icon-user"></span>
              <span>{{ user['custom:name'] }}</span>
            </span>
          </a>
        </ng-container>
        <div class="help" (click)="navigateToHelpFromPath(router.url.split('/')[1])">
          <span class="icomoon icon-help"></span>
        </div>
      </div>
    </nav>
  </ng-container>
</ng-container>



// WEBPACK FOOTER //
// ./src/app/shared/components/rootbar/rootbar.component.html